<template>
  <div class="flex items-center rounded-xl relative border bg-gray-50 dark:bg-gray-950/50">
    <slot>
      <div class="p-3 pr-2">
        <div class="h-8 w-8 rounded-xl bg-primary-100 flex items-center justify-center text-primary-600 dark:bg-primary-500/20 flex-shrink-0">
          <o-icon :icon="icon" />
        </div>
      </div>
    </slot>

    <div class="p-3 pr-6">
      <p class="text-xs opacity-70">
        {{ type }}
      </p>
      <p class="font-semibold text-sm opacity-90">
        {{ title }}
      </p>
      <p v-if="info" class="text-sm opacity-90">
        {{ info }}
      </p>
    </div>

    <div class="absolute top-0 right-0 p-1" @click="$emit('remove')">
      <a class="h-5 w-5 hover:bg-gray-200 transition-all rounded-full flex items-center justify-center text-gray-500 text-xs cursor-pointer">
        <o-icon icon="x" :size="12" />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  type: string
  title: string
  info?: string | null
  icon?: string | null
}

withDefaults(defineProps<Props>(), {
  info: null,
  icon: null,
})

const emit = defineEmits<{
  (e: 'remove'): void
}>()
</script>
